import { render, staticRenderFns } from "./StepDataList.vue?vue&type=template&id=35b79660&scoped=true"
import script from "./StepDataList.vue?vue&type=script&lang=js"
export * from "./StepDataList.vue?vue&type=script&lang=js"
import style0 from "./StepDataList.vue?vue&type=style&index=0&id=35b79660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b79660",
  null
  
)

export default component.exports